import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import MDInputBootstrap from 'components/MDInputBootstrap';

function BootstrapFormField({ label = '', id, helperText, ...rest }) {
  return (
    <FormControl fullWidth variant="standard">
      <InputLabel shrink htmlFor={id} sx={{ marginLeft: '10px' }}>
        {label}
      </InputLabel>
      <MDInputBootstrap variant="standard" id={id} fullWidth {...rest} />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

BootstrapFormField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  helperText: PropTypes.string,
};

export default BootstrapFormField;
